import { useExperiments } from '@wix/fe-essentials-standalone';

import { EXPERIMENTS } from '../constants';

const useIsHireProfessionalInHeaderEnabled = () => {
  const { experiments } = useExperiments({ suspense: false, readOnly: true });
  const experimentValue = experiments.get(EXPERIMENTS.SPECS.HIRE_PROFESSIONAL_IN_HEADER);
  return experimentValue === 'true';
};

export default useIsHireProfessionalInHeaderEnabled;
